import React, { useState, useEffect, useRef } from 'react';

import { Form, Drawer, Space, Button } from 'antd';

import SPDynamicFormRender from 'components/base/SPDynamicFormRender';

import { useCarModelPrice } from 'hooks/product-price/car-model-price';
import CarModelTabs from '../car-model-tabs';

import { JSONS } from 'jsons';
import emiter, { _EVENTS } from '../../../../events';
import {isPhoneFn} from "../../../../utils/tool";

interface IComponentProps {
	enums?: any;
}
const SPDrawer: React.FC<IComponentProps> = props => {
	// 组件所需枚举值
	const { enums } = props;
	// load后的数据值，用来为非表单类组件使用，如状态显示
	const dataRef = useRef({});
	// form引用
	const [mainForm] = Form.useForm();
	// Drawer打开状态
	const [open, setOpen] = useState(false);
	// 是否为只读态，查看场景
	const [disabled, setDisabled] = useState(false);
	// Drawer的操作栏
	const [actionBar, setActionBar] = useState(<></>);
	// 根据只读态，编辑态，标题有所不同。如编辑订单，查看订单等
	const [title, setTitle] = useState('');
	// 拿到查询当前的详情
	const [details, setDetails] = useState();

	// todo:hard code,rebuild to consts
	const drawerWidth = isPhoneFn() ? '80%' : '45%';

	const drawerView = JSONS.productPrice.carModelPrice.drawerView;

	const { drawerSubmit, searchByData } = useCarModelPrice();

	const onOpen = (data: any = {}) => {
		setDetails(data.detail);
		const drawerInfo = data.drawerInfo;
		dataRef.current = data;
		mainForm.resetFields();
		mainForm.setFieldsValue(data);
		setOpen(true);
		setDisabled(drawerInfo.disabled);
		// setActionBar(<ActionBar />);
		setTitle(drawerInfo.title);
	};

	const onClose = () => {
		setOpen(false);
		searchByData();
		dataRef.current = {};
		mainForm.resetFields();
		setDisabled(false);
		// setActionBar(ActionBar);
		setTitle('');
	};

	// const ActionBar = () => {
	// 	return (
	// 		<Space>
	// 			<Button onClick={onClose}>关闭</Button>
	// 			<Button type="primary" onClick={onFinish}>
	// 				保存
	// 			</Button>
	// 		</Space>
	// 	);
	// };

	const onFinish = () => {
		mainForm.validateFields().then(async (fieldsValue: any) => {
			const values = mainForm.getFieldsValue();
			await drawerSubmit(values, dataRef.current);
			onClose();
		});
	};

	useEffect(() => {
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.VIEW, onOpen);
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.ADD, onOpen);
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.EDIT, onOpen);
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.CLOSE_DRAW, onClose);
		return () => {
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.VIEW)
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.ADD)
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.EDIT)
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.CLOSE_DRAW)
		}
	}, []);

	return (
		<>
			<Drawer title={title} width={drawerWidth} onClose={onClose} open={open} destroyOnClose extra={actionBar}>
				<Form form={mainForm} labelCol={{ span: 4 }} disabled={disabled}>
					<SPDynamicFormRender data={drawerView} />
				</Form>
				<CarModelTabs details={details} disabled={disabled} enums={enums} />
			</Drawer>
		</>
	);
};

export default SPDrawer;
